import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { FaPlus, FaEdit, FaEye } from "react-icons/fa";
import Swal from "sweetalert2";
import { terminalesAPI } from "../utils/api";

const initialTurnos = [
  { turno: 1, hra_ini: "05:30:01", hra_fin: "13:30:00" },
  { turno: 2, hra_ini: "13:30:01", hra_fin: "21:00:00" },
  { turno: 3, hra_ini: "21:00:01", hra_fin: "23:59:59" },
  { turno: 4, hra_ini: "00:00:00", hra_fin: "05:30:00" },
];

const formatTimeForInput = (value) => {
  if (!value) {
    return "";
  }
  if (/^\d{2}:\d{2}$/.test(value)) {
    return `${value}:00`;
  }
  return value;
};

const inputStyle = {
  background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
  border: "2px solid #e9ecef",
  borderRadius: "12px",
  padding: "14px 16px",
  fontSize: "14px",
  fontWeight: "500",
  color: "#495057",
};

const buttonIconStyle = {
  width: "38px",
  height: "38px",
  padding: "0",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
};

const statusBadgeStyle = (estatus) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: estatus === "Activo" ? "#2dce89" : "#adb5bd",
  color: "white",
  borderRadius: "12px",
  padding: "0.45rem 0.85rem",
  fontSize: "0.8rem",
  fontWeight: 600,
});

const Terminales = () => {
  const [terminales, setTerminales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    url: "",
    logo: "",
    estatus: "Activo",
    turnos: initialTurnos,
  });
  const [errors, setErrors] = useState({});
  const [currentId, setCurrentId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .modern-select {
        appearance: none !important;
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e") !important;
        background-position: right 14px center !important;
        background-repeat: no-repeat !important;
        background-size: 16px !important;
        padding-right: 44px !important;
      }

      .mobile-button {
        transition: all 0.3s ease !important;
        border-radius: 10px !important;
        font-weight: 600 !important;
        box-shadow: 0 4px 12px rgba(90, 12, 98, 0.15) !important;
      }

      .mobile-button:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 16px rgba(90, 12, 98, 0.2) !important;
      }

      .btn-action-edit,
      .btn-action-view {
        background-color: #7e3866 !important;
        border-color: #7e3866 !important;
        color: white !important;
        transition: all 0.3s ease !important;
        border-radius: 8px !important;
        padding: 8px 12px !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        box-shadow: 0 2px 8px rgba(126, 56, 102, 0.2) !important;
      }

      .btn-action-edit:hover,
      .btn-action-view:hover {
        background-color: #6a2f55 !important;
        border-color: #6a2f55 !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 4px 12px rgba(126, 56, 102, 0.3) !important;
      }

      .swal2-confirm-custom {
        background: linear-gradient(135deg, rgb(90, 12, 98) 0%, rgb(220, 1, 127) 100%) !important;
        border: none !important;
        color: white !important;
        font-weight: 600 !important;
        padding: 12px 24px !important;
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
        box-shadow: 0 4px 12px rgba(90, 12, 98, 0.3) !important;
      }

      .swal2-confirm-custom:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 16px rgba(90, 12, 98, 0.4) !important;
        background: linear-gradient(135deg, rgb(100, 12, 108) 0%, rgb(230, 1, 137) 100%) !important;
      }

      .swal2-cancel-custom {
        background: #6c757d !important;
        border: none !important;
        color: white !important;
        font-weight: 600 !important;
        padding: 12px 24px !important;
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
        box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3) !important;
      }

      .swal2-cancel-custom:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4) !important;
        background: #5a6268 !important;
      }

      .info-item {
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border: 1px solid #e9ecef;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 8px;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      }

      .info-item:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        border-color: #5A0C62;
      }

      .info-label {
        color: #6c757d;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .info-value {
        color: #495057;
        font-size: 16px;
        font-weight: 500;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    cargarTerminales();
  }, []);

  const cargarTerminales = async () => {
    setLoading(true);
    try {
      const response = await terminalesAPI.getAll();
      setTerminales(response.data.terminales || []);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al cargar terminales",
        text: error.response?.data?.error || "No se pudieron obtener las terminales",
      });
    } finally {
      setLoading(false);
    }
  };

  const abrirModalCrear = () => {
    setModalMode("create");
    setCurrentId(null);
    setFormData({
      nombre: "",
      descripcion: "",
      url: "",
      logo: "",
      estatus: "Activo",
      turnos: initialTurnos,
    });
    setErrors({});
    setModalOpen(true);
  };

  const abrirModalEditar = async (id) => {
    setLoading(true);
    try {
      const response = await terminalesAPI.getById(id);
      const terminal = response.data.terminal;
      const turnos = response.data.turnos || initialTurnos;
      setCurrentId(id);
      setModalMode("edit");
      setFormData({
        nombre: terminal.nombre || "",
        descripcion: terminal.descripcion || "",
        url: terminal.url || "",
        logo: terminal.logo || "",
        estatus: terminal.estatus || "Activo",
        turnos: turnos.map((turno) => ({
          turno: turno.turno,
          hra_ini: formatTimeForInput(turno.hra_ini),
          hra_fin: formatTimeForInput(turno.hra_fin),
        })),
      });
      setErrors({});
      setModalOpen(true);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al cargar terminal",
        text: error.response?.data?.error || "No se pudo obtener el registro de terminal",
      });
    } finally {
      setLoading(false);
    }
  };

  const abrirModalVer = async (id) => {
    setLoading(true);
    try {
      const response = await terminalesAPI.getById(id);
      const terminal = response.data.terminal;
      const turnos = response.data.turnos || initialTurnos;
      setCurrentId(id);
      setModalMode("view");
      setFormData({
        nombre: terminal.nombre || "",
        descripcion: terminal.descripcion || "",
        url: terminal.url || "",
        logo: terminal.logo || "",
        estatus: terminal.estatus || "Activo",
        turnos: turnos.map((turno) => ({
          turno: turno.turno,
          hra_ini: formatTimeForInput(turno.hra_ini),
          hra_fin: formatTimeForInput(turno.hra_fin),
        })),
      });
      setErrors({});
      setModalOpen(true);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al cargar terminal",
        text: error.response?.data?.error || "No se pudo obtener el registro de terminal",
      });
    } finally {
      setLoading(false);
    }
  };

  const cerrarModal = () => {
    setModalOpen(false);
  };

  const actualizarCampo = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const actualizarTurno = (index, field, value) => {
    setFormData((prev) => {
      const nuevosTurnos = [...prev.turnos];
      nuevosTurnos[index] = {
        ...nuevosTurnos[index],
        [field]: value,
      };
      return { ...prev, turnos: nuevosTurnos };
    });
  };

  const normalizeTimeValue = (value) => {
    if (!value) return "";
    const trimmed = value.trim();
    if (/^\d{2}:\d{2}$/.test(trimmed)) {
      return `${trimmed}:00`;
    }
    return trimmed;
  };

  const validarFormulario = () => {
    const nuevosErrores = {};

    if (!formData.nombre.trim()) {
      nuevosErrores.nombre = "El nombre es requerido.";
    }
    if (!formData.descripcion.trim()) {
      nuevosErrores.descripcion = "La descripción es requerida.";
    }
    if (!formData.url.trim()) {
      nuevosErrores.url = "La URL es requerida.";
    }
    if (!formData.logo.trim()) {
      nuevosErrores.logo = "El logo es requerido.";
    }
    if (!formData.estatus) {
      nuevosErrores.estatus = "El estatus es requerido.";
    }

    if (!Array.isArray(formData.turnos) || formData.turnos.length !== 4) {
      nuevosErrores.turnos = "Debe configurar los 4 turnos.";
    } else {
      formData.turnos.forEach((turno, index) => {
        const inicio = normalizeTimeValue(turno.hra_ini);
        const fin = normalizeTimeValue(turno.hra_fin);
        if (!inicio) {
          nuevosErrores[`turno_${index}_hra_ini`] = "Hora de inicio requerida.";
        }
        if (!fin) {
          nuevosErrores[`turno_${index}_hra_fin`] = "Hora de fin requerida.";
        }
      });
    }

    setErrors(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const enviarFormulario = async () => {
    if (!validarFormulario()) {
      return;
    }

    setSaving(true);
    const payload = {
      nombre: formData.nombre.trim(),
      descripcion: formData.descripcion.trim(),
      url: formData.url.trim(),
      logo: formData.logo.trim(),
      estatus: formData.estatus,
      turnos: formData.turnos.map((turno) => ({
        turno: parseInt(turno.turno, 10),
        hra_ini: normalizeTimeValue(turno.hra_ini),
        hra_fin: normalizeTimeValue(turno.hra_fin),
      })),
    };

    try {
      if (modalMode === "create") {
        await terminalesAPI.create(payload);
        Swal.fire({
          icon: "success",
          title: "Terminal creada",
          text: "La terminal se creó correctamente.",
        });
      } else {
        await terminalesAPI.update(currentId, payload);
        Swal.fire({
          icon: "success",
          title: "Terminal actualizada",
          text: "Los cambios se guardaron correctamente.",
        });
      }

      cargarTerminales();
      cerrarModal();
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar terminal",
        text: error.response?.data?.error || "Ocurrió un error al guardar la terminal",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredTerminales = terminales.filter((terminal) => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;
    return (
      terminal.nombre.toLowerCase().includes(term) ||
      terminal.descripcion.toLowerCase().includes(term)
    );
  });

  const itemsPerPage = 20;
  const totalPages = Math.max(1, Math.ceil(filteredTerminales.length / itemsPerPage));

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const currentTerminales = filteredTerminales.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div
        className="header pb-8 pt-5 pt-md-8"
        style={{ background: "linear-gradient(135deg, #5A0C62 0%, #DC017F 100%)" }}
      >
        <Container fluid>
          <div className="header-body">
            <Row>
              <Col>
                <h6 className="h2 text-white d-inline-block mb-0"></h6>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Container className="mt--8" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Listado de terminales</h3>
                    <small className="text-muted">Total: {terminales.length} terminales</small>
                  </div>
                  <div className="col text-right">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={abrirModalCrear}
                      className="mobile-button"
                      style={{
                        minWidth: "170px",
                        borderRadius: "10px",
                        padding: "10px 16px",
                        fontWeight: 600,
                      }}
                    >
                      <FaPlus className="mr-2" /> Agregar terminal
                    </Button>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                <Row className="mb-4 g-3">
                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label className="form-control-label">Buscar por nombre o descripción</Label>
                      <Input
                        type="text"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        placeholder="Buscar descripción..."
                        className="form-control-alternative"
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary">{null}</Spinner>
                  </div>
                ) : (
                  <>
                    <Table responsive className="align-items-center table-flush">
                      <thead className="thead-light">
                        <tr>
                          <th>Nombre</th>
                          <th>Descripción</th>
                          <th>URL</th>
                          <th>Logo</th>
                          <th>Estatus</th>
                          <th className="text-right">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentTerminales.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center text-muted py-4">
                              No se encontraron terminales.
                            </td>
                          </tr>
                        ) : (
                          currentTerminales.map((terminal) => (
                            <tr key={terminal.id}>
                              <td>{terminal.nombre}</td>
                              <td>{terminal.descripcion}</td>
                              <td>{terminal.url || "-"}</td>
                              <td>{terminal.logo || "-"}</td>
                              <td>
                                <span style={statusBadgeStyle(terminal.estatus)}>
                                  {terminal.estatus}
                                </span>
                              </td>
                              <td className="text-right">
                                <Button
                                  color="info"
                                  size="sm"
                                  className="btn-icon-only mr-2 btn-action-view"
                                  style={buttonIconStyle}
                                  onClick={() => abrirModalVer(terminal.id)}
                                  title="Ver"
                                >
                                  <FaEye />
                                </Button>
                                <Button
                                  color="warning"
                                  size="sm"
                                  className="btn-icon-only btn-action-edit"
                                  style={buttonIconStyle}
                                  onClick={() => abrirModalEditar(terminal.id)}
                                  title="Editar"
                                >
                                  <FaEdit />
                                </Button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>

                    {filteredTerminales.length > itemsPerPage && (
                      <Row className="mt-3">
                        <Col className="d-flex justify-content-center">
                          <nav aria-label="Paginación de terminales">
                            <ul className="pagination pagination-sm mb-0">
                              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button
                                  className="page-link"
                                  onClick={() => setCurrentPage(currentPage - 1)}
                                  disabled={currentPage === 1}
                                >
                                  «
                                </button>
                              </li>
                              {Array.from({ length: totalPages }, (_, index) => (
                                <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(index + 1)}
                                  >
                                    {index + 1}
                                  </button>
                                </li>
                              ))}
                              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button
                                  className="page-link"
                                  onClick={() => setCurrentPage(currentPage + 1)}
                                  disabled={currentPage === totalPages}
                                >
                                  »
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal isOpen={modalOpen} toggle={cerrarModal} size="lg">
        <ModalHeader className="text-white border-0 position-relative" style={{background: 'linear-gradient(135deg, rgb(90, 12, 98) 0%, rgb(220, 1, 127) 100%)'}}>
          <div className="d-flex align-items-center">
            <h4 className="mb-0 text-white">
              {modalMode === "create" && "Nueva Terminal"}
              {modalMode === "edit" && "Editar Terminal"}
              {modalMode === "view" && "Detalles de la Terminal"}
            </h4>
          </div>
          <button 
            type="button" 
            className="btn-close text-white position-absolute" 
            aria-label="Close"
            onClick={cerrarModal}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              fontWeight: 'bold',
              cursor: 'pointer',
              padding: '0',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              top: '15px',
              right: '15px'
            }}
          >
            ×
          </button>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">Nombre *</Label>
                  <Input
                    type="text"
                    value={formData.nombre}
                    onChange={(e) => actualizarCampo('nombre', e.target.value)}
                    placeholder="Nombre de la terminal"
                    invalid={!!errors.nombre}
                    readOnly={modalMode === 'view'}
                    className="form-control-alternative"
                    style={inputStyle}
                  />
                  {errors.nombre && <div className="text-danger mt-1">{errors.nombre}</div>}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">EstatusX *</Label>
                  {modalMode === 'view' ? (
                    <>
                      <br />
                      <div
                        style={{
                          ...statusBadgeStyle(formData.estatus),
                          width: '100%'
                        }}
                      >
                        {formData.estatus}
                      </div>
                    </>
                  ) : (
                    <Input
                      type="select"
                      value={formData.estatus}
                      onChange={(e) => actualizarCampo('estatus', e.target.value)}
                      invalid={!!errors.estatus}
                      className="form-control-alternative modern-select"
                      style={{
                            width: '100%',
                            marginTop: '0',
                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            border: '2px solid #e9ecef',
                            borderRadius: '12px',
                            padding: '12px 16px',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#495057',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}
                    >
                      <option value="Activo">Activo</option>
                      <option value="Inactivo">Inactivo</option>
                    </Input>
                  )}
                  {errors.estatus && <div className="text-danger mt-1">{errors.estatus}</div>}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">Descripción *</Label>
                  <Input
                    type="text"
                    value={formData.descripcion}
                    onChange={(e) => actualizarCampo('descripcion', e.target.value)}
                    placeholder="Descripción breve"
                    invalid={!!errors.descripcion}
                    readOnly={modalMode === 'view'}
                    className="form-control-alternative"
                    style={inputStyle}
                  />
                  {errors.descripcion && <div className="text-danger mt-1">{errors.descripcion}</div>}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">URL de Evaluaciones de cliente *</Label>
                  <Input
                    type="text"
                    value={formData.url}
                    onChange={(e) => actualizarCampo('url', e.target.value)}
                    placeholder="https://..."
                    invalid={!!errors.url}
                    readOnly={modalMode === 'view'}
                    className="form-control-alternative"
                    style={inputStyle}
                  />
                  {errors.url && <div className="text-danger mt-1">{errors.url}</div>}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">Logo *</Label>
                  <Input
                    type="text"
                    value={formData.logo}
                    onChange={(e) => actualizarCampo('logo', e.target.value)}
                    placeholder="Nombre del archivo de logo"
                    invalid={!!errors.logo}
                    readOnly={modalMode === 'view'}
                    className="form-control-alternative"
                    style={inputStyle}
                  />
                  {errors.logo && <div className="text-danger mt-1">{errors.logo}</div>}
                </FormGroup>
              </Col>
            </Row>

            <h5 className="mt-4">Turnos</h5>
            <Table responsive className="table-sm mb-0">
              <thead>
                <tr>
                  <th>Turno</th>
                  <th>Hora inicio</th>
                  <th>Hora fin</th>
                </tr>
              </thead>
              <tbody>
                {formData.turnos.map((turno, index) => (
                  <tr key={turno.turno}>
                    <td>{turno.turno}</td>
                    <td>
                      <Input
                        type="time"
                        step="1"
                        value={formatTimeForInput(turno.hra_ini)}
                        onChange={(e) => actualizarTurno(index, 'hra_ini', e.target.value)}
                        invalid={!!errors[`turno_${index}_hra_ini`]}
                        readOnly={modalMode === 'view'}
                        className="form-control-alternative"
                        style={inputStyle}
                      />
                      {errors[`turno_${index}_hra_ini`] && (
                        <div className="text-danger mt-1">{errors[`turno_${index}_hra_ini`]}</div>
                      )}
                    </td>
                    <td>
                      <Input
                        type="time"
                        step="1"
                        value={formatTimeForInput(turno.hra_fin)}
                        onChange={(e) => actualizarTurno(index, 'hra_fin', e.target.value)}
                        invalid={!!errors[`turno_${index}_hra_fin`]}
                        readOnly={modalMode === 'view'}
                        className="form-control-alternative"
                        style={inputStyle}
                      />
                      {errors[`turno_${index}_hra_fin`] && (
                        <div className="text-danger mt-1">{errors[`turno_${index}_hra_fin`]}</div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={cerrarModal} disabled={saving}>
            Cerrar
          </Button>
          {modalMode !== "view" && (
            <Button color="primary" onClick={enviarFormulario} disabled={saving}>
              {saving ? <Spinner size="sm">{null}</Spinner> : modalMode === 'create' ? 'Crear terminal' : 'Guardar cambios'}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Terminales;
